// Angular Imports
import { Component, OnInit } from '@angular/core';

// Snagajob
import { getDomainName } from '@snagajob/utils';

// Hub
import { AuthenticationService } from '../../services/authentication.service';
import { getSystemName } from './../../shared/functions';
import { LocalStorageService } from '@libs/services';

@Component({
  template: ``,
  selector: 'app-authentication-logout',
})
export class AuthenticationLogoutComponent implements OnInit {
  constructor(
    private auth: AuthenticationService,
    private localStorageService: LocalStorageService,
  ) {}

  ngOnInit(): void {
    // On logout clear local and session storage
    this.localStorageService.clearLocalStorage({ exemptKeys: ['drafts'] });
    this.localStorageService.clearSessionStorage();

    // call logout on our edge
    this.auth
      .logout()
      .toPromise()
      .then(() => {
        if (window) {
          // we wont have this at compile time since the container is deployed reusably so grab
          // the domain from the domain of the window
          let domain: string = getDomainName(window.location.hostname);
          let system: string = getSystemName(window.location.hostname);

          // force prod to use snagajob.com rather than snagprod.com
          domain = domain === 'snagprod.com' ? 'snagajob.com' : domain;

          // for local development we need to tell the login server in this environment
          // to send back to our machine w/ the SUT instead of the deployed endpoint
          if (domain === 'localhost') {
            system = 'local4200';
            domain = 'snagdev.com';
          }

          // log out of from one login as well by redirecting to the logout end point
          window.location.href = `https://login.${domain}/logout?system=${system}&path=/`;
        }
      });
  }
}
